<template>
  <div class="eat-filters-panel">
    <div class="eat-filters-panel-component hidden">
      <div class="component-background" @click="close(true)" />
      <div class="wrapper no-scrollbar" :class="theme">
        <div class="reset is-uppercase" v-ripple @click="resetFilters">
          <span class="link">{{ $t("reset") }}</span>
        </div>

        <p class="has-text-left subtitle" @click="apply">
          <!-- clearSearch(); clearAll(true); -->
          <i class="fa fa-chevron-left" style="margin-right: 6px" />
          {{ $t("filter.filters") }}
        </p>
        <hr />
        <p class="label has-text-left has-text-grey">Sort By</p>
        <div
          class="buttons discounts has-text-left single-line no-scrollbar"
          style="overflow: scroll; width: 100%; margin-bottom: -2px"
        >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-info': sortBy === 'distance' }"
            @click="sortBy = 'distance'"
            >Distance</span
          >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-info': sortBy === 'alphabet' }"
            @click="sortBy = 'alphabet'"
            >Alphabet</span
          >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-info': sortBy === 'new' }"
            @click="sortBy = 'new'"
            >New</span
          >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-info': sortBy === 'favorite' }"
            @click="
              sortBy = 'favorite';
              favoritesInfo();
            "
          >
            Favorite&nbsp;
            <i class="fa fa-heart has-text-danger" />
          </span>
        </div>
        <hr />
        <p class="label has-text-left has-text-grey">
          Distance
          <span v-show="distance > 15" class="hint has-text-primary">
            Most shops deliver up to 15km
          </span>
        </p>
        <div class="columns is-mobile is-vcentered" style="margin-bottom: 0">
          <div class="column is-narrow" @click="geoInfo">
            <span class="tag is-white" style="width: 60px"
              >{{ distance }} km</span
            >
          </div>
          <div class="column" style="padding: 0">
            <input
              style="width: 100%; padding-right: 15px"
              class="slider is-fullwidth is-large is-circle"
              step="0.1"
              min="1"
              max="25"
              :value="distance"
              type="range"
              @change="setDistance($event)"
            />
          </div>
        </div>
        <p class="label has-text-left has-text-grey">{{ $t("options") }}</p>
        <div class="buttons" style="margin-bottom: 0">
          <span
            class="button is-white is-rounded is-small"
            :class="{ 'is-link': fulfilmentOptions.includes('delivery') }"
            @click="toggleFulfilmentOption('delivery')"
          >
            <i class="fa fa-shipping-fast" />
            &nbsp;{{ $t("commerce.delivery") }}
          </span>
          <span
            class="button is-white is-rounded is-small"
            :class="{ 'is-link': fulfilmentOptions.includes('take-away') }"
            @click="toggleFulfilmentOption('take-away')"
          >
            <i class="fa fa-walking" />
            &nbsp;{{ $t("commerce.take-away") }}
          </span>
          <span
            class="button is-white is-rounded is-small"
            :class="{ 'is-link': fulfilmentOptions.includes('dine-in') }"
            @click="toggleFulfilmentOption('dine-in')"
          >
            <i class="fa fa-users" />
            &nbsp;{{ $t("commerce.dine-in") }}
          </span>
        </div>
        <!-- <div class="buttons currency" style="margin-bottom:0; font-weight:1200">
          <span class="button is-white is-rounded is-small" :class="{'is-link': true}">$</span>
          <span class="button is-white is-rounded is-small">$$</span>
          <span class="button is-white is-rounded is-small">$$$</span>
        </div>-->
        <p class="label has-text-left has-text-grey">Promos</p>
        <div
          class="buttons discounts has-text-left single-line no-scrollbar"
          style="overflow: scroll; width: 100%; margin-bottom: 0"
        >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-link': promoOptions.includes('free-delivery') }"
            @click="togglePromoOption('free-delivery')"
            >{{ $t("delivery.delivery-promo") }}</span
          >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-link': promoOptions.includes('discount') }"
            @click="infoToast('Discount filter coming soon!', 'top')"
            >% Discount</span
          >
          <!-- @click="togglePromoOption('discount')" -->
        </div>
        <p class="label has-text-left has-text-grey">Cuisine</p>
        <div
          class="
            buttons
            categories
            discounts
            has-text-left
            single-line
            no-scrollbar
            gpu-accelerated
          "
          style="padding-bottom: 8px"
        >
          <span
            class="button is-rounded is-white is-small"
            :class="{ 'is-link': cuisineOptions.length === 0 }"
            @click="cuisineOptions = []"
            >Any</span
          >
          <span
            v-for="c in cuisines"
            :key="c"
            v-show="c"
            class="button is-rounded is-white is-small"
            :class="{ 'is-link': cuisineOptions.includes(c) }"
            @click="toggleCuisineOption(c)"
            >{{ c }}</span
          >
        </div>
        <div class="apply-wrapper">
          <span
            class="button is-medium is-fullwidth is-info pulse is-uppercase"
            @click="apply"
            v-ripple
          >
            {{ $t("filter.apply") }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
// import geo from "@/geo";

export default {
  name: "EatFiltersPanel",
  components: {},
  data() {
    return {
      distance: 15,
      openNowToggle: true,
      fulfilmentOptions: ["delivery"],
      promoOptions: [],
      cuisineOptions: [],
      sortBy: "distance",
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    cuisines() {
      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      shops = shops.filter((b) => b.data.categories);
      return [...new Set(shops.map((b) => b.data.categories.split(",")[0]))];
      //   if (this.search && this.search !== "") {
      //     shops = shops.filter((b) => b.name.toLowerCase().includes(this.search));
      //   }
    },
  },
  mounted() {
    EventBus.$on("SET_EAT_FILTER", (f) => {
      if (f === "*free-delivery") {
        // "Free Delivery") {
        this.clearAll(false);
        this.$nextTick(() => (this.promoOptions = ["free-delivery"]));
      } else if (f === "*open-now") {
        this.resetFilters();
        this.openNowToggle = true;
        this.toggleOpenNow(true);
        // setTimeout(() => this.close(false), 1000);
      } else if (f === "*for-you") {
        this.resetFilters();
        this.sortBy = "foryou";
      } else {
        this.clearAll(false);
      }
    });
  },
  methods: {
    close() {
      // used to take a show boolean arg
      EventBus.$emit("APPLY_EAT_FILTERS", this.$data);
      setTimeout(() => {
        this.hideComponent(".eat-filters-panel-component");
      }, 200);
    },
    apply() {
      this.clearSearch();
      this.close(true);
    },
    resetFilters() {
      Object.assign(this.$data, this.$options.data());
      // this.successToast("Reset Filters");
    },
    clearSearch() {
      EventBus.$emit("SHOP_LIST_SEARCH", null);
    },
    toggleOpenNow(val) {
      this.openNowToggle = val;
    },
    setDistance(e) {
      this.distance = Math.round(e.target.value);
      // if (this.distance > 12) {
      //   this.warningToast("Most shops deliver only up to 12km");
      // }
    },
    toggleFulfilmentOption(opt) {
      var index = this.fulfilmentOptions.indexOf(opt);
      if (index > -1) this.fulfilmentOptions.splice(index, 1);
      else this.fulfilmentOptions.push(opt);
    },
    togglePromoOption(opt) {
      var index = this.promoOptions.indexOf(opt);
      if (index > -1) this.promoOptions.splice(index, 1);
      else this.promoOptions.push(opt);
    },
    toggleCuisineOption(opt) {
      var index = this.cuisineOptions.indexOf(opt);
      if (index > -1) this.cuisineOptions.splice(index, 1);
      else this.cuisineOptions.push(opt);
    },
    geoInfo() {
      var geo = this.$store.state.region;
      var msg = `Within ${this.distance} km of ${geo}`;
      this.infoToast(msg, "top");
    },
    favoritesInfo() {
      if (this.$store.state.favorites.length > 0) return; // yes you have favorites
      this.errorToast("You don't have any favorites yet", "top");
    },
    clearAll(show) {
      //   this.warningToast("Clear all", "bottom");
      this.distance = 16; //25;
      this.openNowToggle = false;
      this.fulfilmentOptions = ["delivery"];
      this.promoOptions = [];
      this.cuisineOptions = [];
      this.sortBy = "distance";
      this.close(show);
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* height: -webkit-fill-available; */
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
  position: absolute;
  top: 0px;
  width: 100vw;
  max-width: 500px;
  right: 0;
  height: 100vh;
  /* height: -webkit-fill-available; */
  /* max-height: 95vh; */
  backdrop-filter: blur(18px);
  background-color: rgba(255, 255, 255, 0.85);
  /* background-color: #333; */
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  /* z-index: 4; // changed to 22 to go above back button */
  z-index: 22;
  /* border-bottom-right-radius: 25px;
  border-bottom-left-radius: 25px; */
}
.dark {
  /* background-color: rgba(17, 34, 51, 0.85);
  color: white; */
  /* background-color: #1f1b2494; */
  background-color: rgb(59, 59, 59);
  color: rgb(182, 200, 218);
}
.subtitle {
  margin: 6px;
}
.dark .subtitle {
  color: rgba(255, 255, 255, 0.7);
}
.buttons .button {
  padding: 0 9px;
}
/* .no-scrollbar::-webkit-scrollbar {
  display: none;
} */
.pulse {
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px gold;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
  }
}
.btns .button {
  padding: 8px;
}
.btns .is-danger {
  margin-right: 11px;
}
input.slider {
  margin: 0 0;
}
.currency span {
  font-weight: bold;
  width: 42px;
}
.categories {
  width: 100%;
  /* height: calc(100vh - 450px); */
  max-height: calc(100vh - 450px);
  /* max-height: 200px; */
  margin-bottom: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
/* .clear-all {
  width: 130px;
  height: 25px;
} */
.apply-wrapper {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: center;
  padding: 10px;
}
.hint {
  font-size: 0.8em;
  opacity: 0.9;
  font-weight: 500;
  margin-left: 4px;
  text-shadow: 0 0 1px white;
}
.link {
  border-bottom: 1px #ccc dotted;
}
.reset {
  float: right;
  padding: 8px;
  font-weight: 500;
  opacity: 0.8;
  color: grey;
}
hr {
  background-color: grey;
  opacity: 0.1;
  margin: 12px 0;
}
</style>